/**
 * "Choose a password" + "Confirm password" for the portal's set-password
 * pages (verify email, accept invitation, reset). The strength rule is the
 * backend's (8+ characters, an uppercase letter and a number); the server
 * still has the last word.
 */
import React from 'react';
import { inputClass, labelClass } from '../../components/formStyles';
import { PASSWORD_REQUIREMENTS_HINT } from '../../utils/password';

interface Props {
  password: string;
  confirm: string;
  onPassword: (value: string) => void;
  onConfirm: (value: string) => void;
  disabled?: boolean;
  /** Field problem to show under the confirm box */
  problem?: string | null;
}

export function PortalPasswordFields({ password, confirm, onPassword, onConfirm, disabled, problem }: Props) {
  return (
    <>
      <div>
        <label htmlFor="portal-password" className={labelClass}>Choose a password</label>
        <input
          id="portal-password" type="password" autoComplete="new-password" className={inputClass + ' min-h-[44px] text-base'}
          value={password} onChange={(e) => onPassword(e.target.value)} disabled={disabled} required aria-describedby="portal-password-hint"
        />
        <p id="portal-password-hint" className="mt-1 text-xs text-gray-500">{PASSWORD_REQUIREMENTS_HINT}</p>
      </div>
      <div>
        <label htmlFor="portal-password-confirm" className={labelClass}>Confirm password</label>
        <input
          id="portal-password-confirm" type="password" autoComplete="new-password" className={inputClass + ' min-h-[44px] text-base'}
          value={confirm} onChange={(e) => onConfirm(e.target.value)} disabled={disabled} required
          aria-invalid={!!problem} aria-describedby={problem ? 'portal-password-problem' : undefined}
        />
        {problem && <p id="portal-password-problem" className="mt-1 text-xs text-red-700">{problem}</p>}
      </div>
    </>
  );
}
